export default __webpack_public_path__ + "static/media/ic_close.c1ef2607.svg";